export const GET_DASHBOARD_DATA = "dashboard/GET_DASHBOARD_DATA";
export const REFRESH_DASHBOARD_DATA = "dashboard/REFRESH_DASHBOARD_DATA";
